/**
 * The app's public view paths — the five surfaces that render for somebody with no session at all: the
 * chat-snapshot viewer (`/share`, `/share/<id>`), a file handed beyond its workspace (`/shared`,
 * `/shared/<id>`), a read-only shared dashboard (`/dashboards/shared`, `/dashboards/shared/<id>`), a
 * shared automation's results (`/scheduled/shared`, `/scheduled/shared/<id>`), and a diagram snapshot
 * (`/diagrams/shared`, `/diagrams/shared/<id>`).
 */
const PUBLIC_VIEW_PREFIXES = [
  '/share',
  '/shared',
  '/dashboards/shared',
  '/scheduled/shared',
  '/diagrams/shared',
];

/**
 * True for a public view path — a prefix itself or anything nested under it, but never a lookalike like
 * `/shareholders` or `/shared-with-me`.
 *
 * Single source of truth for the boot bypass and AppShell's chrome/side-effect gating, and it now guards
 * five features. A path listed here renders with no `AuthGate`, no `TeamsOnlyGate`, no `MaintenanceGate`,
 * no identity bootstrap, no Teams SDK and no `/health` poll — so anything reachable at one of these paths
 * has to work with no session, no identity and no Teams context.
 */
export function isPublicViewPath(pathname: string): boolean {
  return PUBLIC_VIEW_PREFIXES.some(
    (prefix) => pathname === prefix || pathname.startsWith(`${prefix}/`),
  );
}
